<template>
  <div>
    <h1 class="text-center">Solicitud para restablecer contraseña</h1>
    <p class="text-center"> Ingrese su correo electrónico al cual se le enviarán las instrucciones para reestablecer su clave.</p>
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <!-- Input Addons -->

            <div class="box-body">
              <form class="ui form solicitudForm"  @submit.prevent="checkData">


                  <h4>Correo electrónico</h4>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="far fa-envelope" aria-hidden="true"></i>
                    </span>
                    <input class="form-control" name="email" v-model="email" placeholder="Correo electrónico" type="email" required>
                  </div>
                  <br />
                  <div class="col-md-12 text-center" >
                      <button type="submit" v-bind:class="'btn btn-primary btn-lg ' + loading">
                      <i class="el-icon-loading" v-if="loadingGif"/>
                      Enviar solicitud
                      </button>
                  </div>

              </form>

              <!-- /input-group -->
            </div>
            <br>
            <div class="row">
              <div class="col-md-12 text-center" v-if="response" >
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <div class="info-box ">
                      <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                      <div class="info-box-content">
                        <span class="info-box-text">Advertencia</span>
                        <span class="info-box-info">{{response}}</span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  <!-- /.info-box -->
                </div>
              </div>
              <div class="col-md-12 text-center" v-if="success" >
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <div class="info-box ">
                      <span class="info-box-icon bg-green"><i class="ion ion-android-checkmark-circle"></i></span>
                      <div class="info-box-content">
                        <span class="info-box-text">Información</span>
                        <span class="info-box-info">{{success}}</span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  <!-- /.info-box -->
                </div>
                </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
require('moment')
import datepicker from 'vue-date-picker'
import api from '../../api'

export default {
  name: 'Restablecer',
  components: { datepicker },
  computed: {
    datetime () {
      return new Date()
    }
  },
  data (router) {
    return {
      section: 'Reestablecer',
      loading: '',
      loadingGif: false,
      email: '',
      response: null,
      success: null
    }
  },
  methods: {
    clearInput (vueModel) {
      vueModel = ''
    },
    checkData () {
      const {email} = this

      this.loadingGif = true
      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')
      this.$confirm('¿Realmente desea Restablecer su Contraseña?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      })
      .then(() => {
        api.request('GET', 'api/solicitarReestablecimientoPsw' + '?email=' + email)
        .then(response => {
          this.loadingGif = false
          this.toggleLoading()
          var data = response.data
          /* Checking if error object was returned from the server */
          if (response.data.error) {
            var errorName = response.data.error.name
            if (errorName) {
              console.log(errorName)
              if (errorName === 'InvalidArgumentError') {
                this.response = 'Los datos suministrados son incorrectos.'
              } else if (errorName === 'NotFoundError') {
                this.response = 'Se ha producido un error inesperado.'
              } else {
                this.response = errorName
              }
            } else {
              this.response = data.error
            }

            return
          } else {
            if (data.success) {
              this.success = data.success
              this.email = ''
            }
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response = 'Error al conectarse con el servidor, contacte al administrador.'
          this.toggleLoading()
        })
      })
      .catch(error => {
        this.loadingGif = false
        console.log(error)
      })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
      this.success = ''
    }
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}

/*----------PAPER-----------*/
/* form starting stylings ------------------------------- */
.group        {
  position:relative;
  margin-bottom:45px;
}
input         {
  font-size:18px;
  padding:10px 10px 10px 5px;
  display:block;
  width: 100%;
  border:none;
  border-bottom:1px solid #757575;
}
input:focus     { outline:none; }

/* LABEL ======================================= */
label      mo    {
  color:#999;
  font-size:18px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}

/* active state */
input:focus ~ label, input:valid ~ label    {
  top:-20px;
  font-size:10px;
  color:#5264AE;
}

/* BOTTOM BARS ================================= */
.bar  { position:relative; display:block; width:100%; }
.bar:before, .bar:after   {
  content:'';
  height:2px;
  width:0;
  bottom:1px;
  position:absolute;
  background:#5264AE;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}
.bar:before {
  left:50%;
}
.bar:after {
  right:50%;
}

/* active state */
input:focus ~ .bar:before, input:focus ~ .bar:after {
  width:50%;
}

/* HIGHLIGHTER ================================== */
.highlight {
  position:absolute;
  height:60%;
  width:100px;
  top:25%;
  left:0;
  pointer-events:none;
  opacity:0.5;
}

/* active state */
input:focus ~ .highlight {
  -webkit-animation:inputHighlighter 0.3s ease;
  -moz-animation:inputHighlighter 0.3s ease;
  animation:inputHighlighter 0.3s ease;
}

/* ANIMATIONS ================ */
@-webkit-keyframes inputHighlighter {
  from { background:#5264AE; }
  to  { width:0; background:transparent; }
}
@-moz-keyframes inputHighlighter {
  from { background:#5264AE; }
  to  { width:0; background:transparent; }
}
@keyframes inputHighlighter {
  from { background:#5264AE; }
  to  { width:0; background:transparent; }
}

</style>



// WEBPACK FOOTER //
// Reestablecer.vue?6bcda33c